import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getDepartmentsApi,
  saveDepartmentApi,
  deleteDepartmentApi,
} from "../../apiservice/hrpayroll";

export const fetchDepartmentsList = createAsyncThunk(
  "departments/fetchDepartmentsList",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getDepartmentsApi(null);
      return response.data.map((d) => ({
        department_id: d.id,
        department_name: d.name,
      }));
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const createOrUpdateDepartment = createAsyncThunk(
  "departments/createOrUpdateDepartment",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await saveDepartmentApi(payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const deleteDepartment = createAsyncThunk(
  "departments/deleteDepartment",
  async (department_id, { rejectWithValue }) => {
    try {
      const response = await deleteDepartmentApi({ department_id });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
